import { Box, BoxProps } from "@mui/material";
import { ReactNode } from "react";

type PageLayoutProps = {
  header?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
} & BoxProps;

const PageLayout = ({
  header,
  children,
  footer,
  ...others
}: PageLayoutProps) => {
  return (
    <Box display="flex" flexDirection="column" height="100%" {...others}>
      {header && <Box>{header}</Box>}

      <Box
        flex={1}
        overflow="hidden"
        display="flex"
        flexDirection="column"
        mt={header ? 1 : 0}
      >
        {children}
      </Box>

      {footer && <Box>{footer}</Box>}
    </Box>
  );
};

export default PageLayout;
